import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/VeeValidate";
import middleware from "./router/middleware";
import ACLService from "./services/ACLService";
// import axios from "axios"; // axios
// import cookie from "js-cookie"; // js-cookie
import "./assets/scss/main.scss"; // Styles: SCSS
import "./registerServiceWorker";
import wb from "./registerServiceWorker";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import VueMask from "v-mask";
import JsonExcel from "vue-json-excel";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

Vue.component("downloadExcel", JsonExcel);

Vue.use(VueMask);

const permissions = [
  {
    name: "dashboard",
    permission: "all"
  }
];
// Or as a directive
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

middleware.register({ store, router });
window.ACLService = new ACLService(permissions);
// Or only as a filter
import { VueMaskFilter } from "v-mask";
Vue.filter("VMask", VueMaskFilter);
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
// import "./utils/axios";
// import axios from "axios";
// import Cookies from "js-cookie";

Vue.use(require("vue-moment"));
Vue.prototype.$workbox = wb;
// const link = window.location.origin;
Vue.config.productionTip = false;
// const axiosOptoins = {
//   baseURL: process.env.VUE_APP_API_URL,
//   timeout: 180000, // 3 menit
//   headers: {}
// };
// if (cookie.getJSON("userdata") !== undefined) {
//   const auth = cookie.getJSON("userdata");
//   store.commit("SET_LOGIN", auth);

//   axiosOptoins.headers.Authorization = "Bearer " + auth.access_token;
//   store.commit("retrieveToken", auth.access_token);
// }
// Vue.prototype.$axios = axios.create(axiosOptoins);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
